import {ListItem, ListItemAvatar, ListItemButton, ListItemText, Skeleton, Typography} from '@mui/material';
import {MouseEvent, useState} from 'react';
import {useTranslation} from 'react-i18next';
import socket, {IResponse} from '@sockets';
import IChannel from './IChannel';
import LoadingButton from '@mui/lab/LoadingButton';
import {Link} from 'react-router-dom';

interface IProps {
	channel: IChannel;
	onJoin: (channel: IChannel) => void;
}

export default function ChannelItem({channel, onJoin}: IProps) {
	const [loading, setLoading] = useState(false);
	const {t} = useTranslation();
	
	const handleJoinBtnClicked = (event: MouseEvent<HTMLButtonElement>) => {
		setLoading(true);
		socket.emit('network:join_channel', channel.id, (data: IResponse<IChannel>) => {
			setLoading(false);
			if (data.success) {
				data.result.lastTime = new Date(data.result.lastTime);
				onJoin(data.result);
			} else {
				// TODO show error snack
			}
		});
	};
	return (
		<ListItem
			secondaryAction={
				<LoadingButton
					disabled={!channel.name}
					loading={loading}
					sx={{
						bgcolor: (theme) => theme.palette.mode === 'light' ? 'grey.A200' : 'background.default',
						fontSize: (theme) => theme.typography.fontSize - 2
					}}
					className="w-20 text-center rounded"
					onClick={handleJoinBtnClicked}>
					{t('membership')}
				</LoadingButton>
			}
			sx={{
				borderColor: (theme) => theme.palette.mode === 'light' ? 'secondary.100' : theme.palette.grey[700],
				bgcolor: (theme) => theme.palette.mode === 'light' ? 'secondary.50' : 'background.paper'
			}} className="rounded border mb-2 p-0">
			<ListItemButton className="p-2" component={Link} state={{channel}}
			                to={channel.name ? `/network/${channel.id}` : ''}>
				<ListItemAvatar>
					{
						channel.name ?
							<img className="w-10 h-10 rounded object-cover" src={channel.image} alt={channel.name}/>
							:
							<Skeleton width={40} height={40} variant="rounded"/>
					}
				</ListItemAvatar>
				<ListItemText
					primary={channel.name ?
						<Typography sx={{
							color: (theme) => theme.palette.mode === 'light' ? 'grey.800' : 'grey.100',
							fontSize: (theme) => theme.typography.fontSize
						}} className="font-medium">{channel.name}</Typography>
						:
						<Skeleton className="w-3/5"/>}/>
			</ListItemButton>
		</ListItem>
	);
}
